export * from './TextAlignCenterJustifyIcon';
export * from './TextAlignCenterJustifyIcon16Light';
export * from './TextAlignCenterJustifyIcon16Regular';
export * from './TextAlignCenterJustifyIcon16Solid';
export * from './TextAlignCenterJustifyIcon20Light';
export * from './TextAlignCenterJustifyIcon20Regular';
export * from './TextAlignCenterJustifyIcon20Solid';
export * from './TextAlignCenterJustifyIcon24Regular';
export * from './TextAlignCenterJustifyIcon24Solid';
export * from './TextAlignCenterJustifyIcon32Regular';
export * from './TextAlignCenterJustifyIcon64Regular';
